<script>
import  ApexCharts from "apexcharts";

import numeral from 'numeral'

export default {
    name: "Charts",

    data() {
        return {
            summary: {
                day: {}, week: {}, month: {}
            },

            chart: {
                chart: {
                    height: 320,
                    type: 'bar',
                    zoom: {
                        enabled: false
                    }
                },
                series: [{
                    name: 'Total Requests',
                    data: []
                }],
                plotOptions: {
                    bar: {
                        borderRadius: 10,
                        dataLabels: {
                            position: 'top', // top, center, bottom
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                      return  '$' + numeral(val).format('0,0');
                    },
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        FontFace: 'Oxanium',
                        colors: ["#304758"]
                    }
                },

                xaxis: {
                    categories: [],
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    tooltip: {
                        enabled: true,
                    }
                },
                yaxis: {
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false,
                    },
                    labels: {
                        show: false,
                        formatter: function (val) {
                            return numeral(val).format('0,0');
                        }
                    }
                }
            }
        }
    },

    mounted() {
        this.loadData()
    },
    methods: {
        loadData() {
            this.$http.get('chart/requests').then(response => {
                let data = (response.data.data)
                this.chart.xaxis.categories = Object.keys(data)
                this.chart.series[0].data = Object.values(data).map(a => a.all)

                new ApexCharts(document.getElementById('requests'), this.chart).render()
            })
        }
    }
}
</script>

<template>
    <div id="requests"></div>
</template>

<style scoped>

</style>
